import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FiChevronDown } from 'react-icons/fi';

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeQuestionId: null
    };
  }

  toggleQuestion = (id) => {
    this.setState(prevState => ({
      activeQuestionId: prevState.activeQuestionId === id ? null : id
    }));
  };

  render() {
    const faqs = [
      {
        id: 1,
        question: "Como funciona o seu programa de perda de gordura?",
        answer: "Eu crio planos personalizados combinando treinos metabólicos, orientações nutricionais e estratégias de recuperação. Você receberá instruções passo a passo, demonstrações em vídeo e acompanhamento da evolução – tudo pelo aplicativo.",
        category: 'programa'
      },
      {
        id: 2,
        question: "O que torna sua abordagem diferente?",
        answer: "Com mais de 12 anos de experiência treinando clientes, desenvolvi um método que combina protocolos de HIIT e treinamento de força com alimentação sustentável – sem dietas extremas. O aplicativo me permite ajustar seu plano com base no seu progresso e feedback.",
        category: 'especialização'
      },
      {
        id: 3,
        question: "Preciso de equipamentos?",
        answer: "Não é necessário equipamento! Meus circuitos são projetados para queimar gordura usando apenas seu corpo. Elásticos de resistência podem potencializar os treinos, mas não são obrigatórios.",
        category: 'programa'
      },
      {
        id: 4,
        question: "Com que frequência vou interagir com você?",
        // answer: "Você receberá check-ins semanais em vídeo através do aplicativo, além de lembretes diários de responsabilidade. Eu reviso todos os seus dados de progresso e ajusto seu plano todos os domingos.",
        answer: "Você terá um acompanhamento completo a cada 3 semanas pelo aplicativo, mas pode me enviar mensagens de suporte sempre que precisar.",
        category: 'suporte'
      },
      {
        id: 5,
        question: "Quando recebo o eBook gratuito?",
        answer: "Imediatamente após se inscrever! Você terá acesso imediato para baixar o eBook 'Dieta Sustentável para Perda de Gordura' assim que começar seu teste grátis."
      },
      {
        id: 6,
        question: "O que acontece após o período de 14 dias de teste grátis?",
        answer: "Sua adesão será renovada automaticamente pelo aplicativo por R$149.90/mês, a menos que você cancele. Você continuará com acesso completo ao aplicativo, suporte 1:1 e quaisquer futuras atualizações do eBook."
      },
    ];

    return (
      <section id="faq" className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            className="text-3xl font-bold text-center mb-12"
          >
            Suas Perguntas Sobre Perda de Gordura Respondidas
          </motion.h2>

          <div className="max-w-3xl mx-auto">
            {faqs.map((faq) => (
              <motion.div 
                key={faq.id}
                className="mb-4 bg-white rounded-lg shadow-sm"
                whileHover={{ scale: 1.01 }}
              >
                <button
                  onClick={() => this.toggleQuestion(faq.id)}
                  className="w-full text-left px-6 py-4 flex justify-between items-center"
                >
                  <span className="text-lg font-semibold pr-4">{faq.question}</span>
                  <motion.span
                    animate={{ rotate: this.state.activeQuestionId === faq.id ? 180 : 0 }}
                  >
                    <FiChevronDown className="text-blue-500 text-xl" />
                  </motion.span>
                </button>

                <AnimatePresence>
                  {this.state.activeQuestionId === faq.id && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      className="overflow-hidden"
                    >
                      <div className="px-6 pb-4 pt-2 border-t border-blue-100">
                        <p className="text-gray-600 leading-relaxed">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default FAQ;
